import Loves from 'components/Loves/Loves';
import { withLovesProps } from 'viewModel/loves/withLovesProps';

export default withLovesProps(Loves);
